module.exports = __webpack_public_path__ + "img/racecourse-turffontein-turf-inner-2600.a872c47b.svg";